import $ from "jquery";

export const vacancySection = () => {
  const elms = {
    buttonClearFilter: ".js-clear-vacancy-filter",
    vacancyFilterItem: ".vacancy__filter-item input[type='checkbox']",
    vacancyItems: ".vacancy__item",
    test: ".v3-form",
    removeFilter: ".remove-filter",
    toggleFilter: ".js-toggle-mobile-filter",
  };

  const init = () => {
    clearVacancyFilter();
    attachFilterEvents();
    removeSelectedFIlter();
    openFIlterBox();
    test();
  };

  const test = () => {
    $(elms.test).on("submit", function () {
      // console.log("woyyy");
    });
  };

  const openFIlterBox = () => {
    $(elms.toggleFilter).on("click", function() {
      const scrollTopval = $("#vacancy-section").offset().top;
      const isToggled = $(this).hasClass("is-toggled");
      $(elms.toggleFilter).toggleClass("is-toggled", !isToggled);
      $("#vacancy-filter").toggleClass("is-active", !isToggled);

      $(document).scrollTop(scrollTopval-80);
    })
  }

  const clearVacancyFilter = () => {
    $(elms.buttonClearFilter).on("click", function () {
      $(elms.vacancyFilterItem).prop("checked", false);
      $("body").on(
        "change",
        ".vacancy__filter-item input[type='checkbox']",
        function () {
          filterVacancies();
        },
      );
    });
  };

  const removeSelectedFIlter = () => {
    $(elms.removeFilter).on("click", function() {
      const termId = $(this).data("termid");
      // const termName = $(this).data("name");
      $(`input#term-${termId}`).prop("checked", false);
      filterVacancies();      
    });
  };

  const attachFilterEvents = () => {
    $(elms.vacancyFilterItem).on("change", function () {
      $("body").on(
        "change",
        ".vacancy__filter-item input[type='checkbox']",
        function () {
          filterVacancies();
        },
      );
    });
  };

  const filterVacancies = () => {
    const selectedExperience = getSelectedValues("vacancy-experience");
    const selectedDepartments = getSelectedValues("vacancy-department");

    $(".vacancy__item").each(function () {
      const item = $(this);
      const expData = item.data("exp");
      const teamData = item.data("team");

      const experienceMatch =
        selectedExperience.length === 0 ||
        selectedExperience.some((exp) => expData.includes(exp));
      const departmentMatch =
        selectedDepartments.length === 0 ||
        selectedDepartments.some((dep) => teamData.includes(dep));

      if (experienceMatch && departmentMatch) {
        item.show();
      } else {
        item.hide();
      }
    });

    $(`.js-filter-display-exp`).each(function() {
      const item = $(this);
      const expData = String(item.data("exp"));

      const experienceMatch =
        selectedExperience.some((exp) => expData.includes(exp));

        if (experienceMatch) {
          item.addClass("is-selected");
        } else { 
          item.removeClass("is-selected");
        }
    })
    
    $(`.js-filter-display-dep`).each(function() {
      const item = $(this);
      const teamData = String(item.data("team"));

      const departmentMatch =
        selectedDepartments.some((dep) => teamData.includes(dep));

        if (departmentMatch) {
          item.addClass("is-selected");
        } else { 
          item.removeClass("is-selected");
        }
    });
  };

  const getSelectedValues = (filterName) => {
    return $(`input[name="${filterName}"]:checked`)
      .map(function () {
        return parseInt(this.id.replace("term-", ""), 10);
      }) 
      .get();
  };

  init();
};
